import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@/components/common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_WORKFLOW_AUTOMATION_AGENTS)

export default function AiWorkflowAutomation() {
  
const WE_CAN_BUILD = [
 {title: 'Intelligent Document-to-Workflow Processing',
    desc: 'Use AI to interpret incoming documents, extract relevant information and initiate the appropriate business process. Conventional validation rules and approval steps can help ensure that extracted information is checked before further action.',
    subtitle:'Example — Procurement',
    example:' A purchasing application could extract supplier details from submitted quotations, organize line items and prepare a comparison for procurement staff to review.' },
     {title: 'Automated Request Classification & Routing',
    desc: 'Classify incoming requests by subject, urgency, department or other relevant attributes, then route them to the correct team or workflow.',
    subtitle:'Example — IT Operations',
    example:'An internal helpdesk could categorize incoming tickets, identify common issue types, suggest troubleshooting steps and route unresolved cases to the appropriate support team.' },
     {title: 'AI-Assisted Multi-Step Workflows',
    desc: 'Combine AI reasoning and information retrieval with application APIs, defined business rules and workflow orchestration. Depending on the use case, an AI agent can perform a sequence of permitted tasks while keeping approvals and restrictions in place.',
    subtitle:'Example — Sales Operations',
    example:'An assistant could collect information from an approved CRM, prepare a customer meeting summary, draft follow-up actions and present them to a sales representative for approval.' },
     {title: 'Exception Identification & Resolution Support',
    desc: 'Use AI to summarize unusual cases, identify missing information and recommend possible next steps when a process cannot proceed normally.',
    subtitle:'Example — Insurance Operations',
    example:'A claims application could identify missing documents, summarize inconsistencies and flag cases that need further review. Final claim decisions remain subject to authorized procedures.' },
     {title: 'Cross-System Information Coordination',
    desc: 'Connect business applications so information can move between systems with less manual re-entry. AI can help interpret unstructured inputs, while APIs and deterministic integrations handle structured transactions.',
    subtitle:'Example — Order Management',
    example:'A system could interpret a customer email, identify the relevant order, prepare an update request and route it through the existing approval process.' },
     {title: 'AI Agents for Defined Business Tasks',
    desc: `Develop task-oriented agents that can access approved information and use specified tools to complete bounded activities. Agent permissions, action limits, audit trails and human approval can be designed according to the risk involved.
An AI agent is not necessarily a fully autonomous digital employee. In many business environments, a controlled assistant that performs selected steps and requests approval is the more appropriate solution.`,
    subtitle:'',
    example:'' },
  
  
]

const AI_CREATE_VALUES = [
  { title: 'Government & Public Administration',desc: 'Classify incoming submissions, organize field reports, summarize programme updates and route requests to responsible teams.' },
  { title: 'Banking & Financial Services',desc: 'Assist with document intake, case preparation, service-request routing and exception review.' },
  { title: 'Healthcare Administration',desc: 'Support appointment enquiries, administrative document processing and internal task coordination without replacing professional clinical judgment.' },
  { title: 'Manufacturing & Supply Chain',desc: 'Organize purchase requests, process supplier documentation and assist with inventory or maintenance workflows.' },
  { title: 'Retail & E-commerce',desc: 'Classify customer enquiries, support order-related workflows and coordinate returns or service requests.' },
  { title: 'Enterprise IT & Operations',desc: 'Assist with ticket triage, incident summaries, knowledge retrieval and routine operational reporting.' }, 
]



const INTEGRATING_AI = [
  { title: `Understand the Process`, desc: 'Map the current workflow, identify bottlenecks and establish the business outcome to improve.', },
  { title: 'Identify Suitable Tasks', desc: 'Separate predictable rule-based activities from tasks where AI interpretation or generation adds value.', },
  { title: 'Design the Workflow', desc: 'Define system integrations, AI responsibilities, validation rules, escalation paths and approval requirements.', },
  { title: 'Human Oversight', desc: 'Route sensitive, ambiguous or high-impact requests for appropriate review.', },
  { title: 'Develop & Integrate', desc: 'Build the application components, connect APIs and implement appropriate access controls and logging.', },
  { title: 'Test Real-World Scenarios', desc: 'Evaluate accuracy, exceptions, failures, permissions, recovery and the consequences of incorrect outputs.', },
  { title: 'Monitor & Improve', desc: 'Measure operational results and refine the workflow as processes, data and business needs evolve.', },
 
]
  return (
    <>
     <MetaInfo
      title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Conversational AI Solutions */}
              {label}
             </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build intelligent chatbots that deliver natural, human-like conversations. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>

                         {/* section 1 */}
                          <section className="bg-linear-gradient-light section-py " >
                        <div className="container">
                             
                  
                          {/* Row 2 — */}
                           <p className='text-center' data-aos="fade-down">
                              Many business processes involve more than repetitive data entry. Teams must interpret incoming information, identify the appropriate next step, retrieve data from different systems, apply business rules and coordinate actions across departments.
                           </p>
                        
                              <p className='text-center' data-aos="fade-down">
                               Traditional automation is effective when processes follow predictable rules. Artificial Intelligence can extend these workflows by helping applications interpret documents, classify requests, summarize information and respond to less structured inputs.
                           </p>
                           <p className='text-center' data-aos="fade-down">
                              CruxBytes can develop AI-enabled workflow automation and agent-based applications that combine intelligent processing with established software systems. We focus on practical improvements to existing business operations, helping organizations reduce avoidable manual effort while retaining appropriate control over important decisions.
                           </p>
                           <h6 className='pt-4 text-center'>What AI Workflow Automation Can Do</h6>
                          <div className="wcs-grid wcs-grid--3 pt-4">
                            {WE_CAN_BUILD.map((card, i) => (
                              <div
                                key={card.title}
                                className="wcs-card-offer"
                                data-aos="fade-left"
                                data-aos-delay={(i % 3) * 80}
                              >
                                {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
                                <h3 className="wcs-offer-title">{card.title}</h3>
                                <p className="wcs-offer-desc" style={{ whiteSpace: 'pre-line' }}>{card.desc}</p>
                               
                               {card.example !== "" && <><h6 className='pt-4'>{card.subtitle}</h6> 
                               <p className="wcs-offer-desc">{card.example}</p></>}
                              </div>
                            ))}
                          </div>
                        </div>
                      </section>
                      {/* section 2 */}
                      <section className="section-py " aria-labelledby="pux-outcomes-heading">
                    <div className="container">
                      <div className="sc-ai-row sc-tm-row--sticky-heading">
                        <div className="sc-tm-content" data-aos="fade-left">        
                       <h2 id="impact-heading" >
                              <span className="impact-heading-dark">Where These Solutions</span>
                              <span className="impact-heading-light">Can Help</span>
                            </h2>
                            
                        </div>
                        <div  data-aos="fade-right">
                          <div className="wcs-grid wcs-grid--3">
                            {AI_CREATE_VALUES.map((card, i) => (
                              <div
                                key={card.title}
                                className="wcs-card wcs-card--static wcs-card--start  bg-peach"
                                data-aos="fade-up"
                                data-aos-delay={(i % 3) * 80}
                              >             
                                <h3 className="wcs-title"  >{card.title}</h3>
                                <p className="wcs-desc">{card.desc}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                  
                      </div>
                     
                    <div className="comparison-intro mb-0" data-aos="fade-left">
                    <div className='pt-4 d-flex align-items-center'>
                      <p>These are illustrative applications. Feasibility depends on available data, existing systems, process complexity and the safeguards required.</p>
                  </div>
                  
                    <div className="wcs-actions comparison-intro-cta ms-4"  data-aos="fade-right">
                      <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                                    Get Started
                        </Button>
                    </div>
                  </div>
                    </div>
                  </section>
                  
                    {/* ── Section 3 */}
                          <section className="section-py  bgs-section--tint" aria-labelledby="egovernance-partner-heading" style={{ borderRadius:"0" }}>
                            
                  
                            <div className="container">
                             <div className="" data-aos="fade-up">
                                <div className="section-card__content ">
                                  <h2 className='text-center' id="egovernance-partner-heading">
                                    How We Approach AI Automation
                                  </h2>
                                 
                                </div>
                            <p data-aos="fade-up" className='section-px2'>Generative AI systems can produce inaccurate or incomplete responses. A reliable solution therefore requires more than connecting an application to a language model. Depending on the use case, our development considerations include:</p>
                              <div className="wcs-grid">
                                {INTEGRATING_AI.map((item, i) => (
                                  <div
                                    key={item.title}
                                    className="wcs-card   bg-white"
                                    data-aos="fade-up"
                                    data-aos-delay={i * 80}
                                  >
                                    <h3 className="text-secondary wcs-title" >0{i+1}</h3>
                                    {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                                    {/* <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" /> */}
                                    <h3 className="text-secondary wcs-title">{item.title}</h3>
                                    <p className="text-secondary wcs-desc">{item.desc}</p>
                                  </div>
                                ))}
                              </div>
                              
                              
                              </div>
                            </div>
                          </section>
                           {/* Section4 */}
                        <section className="section-py ">
                                  <div className="container ">
                          <div className="on-demand-split">
                                    {/* ── LEFT ── */}
                           <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
                          
                            <div className="cp-timeline-header">
                              <h2 >Automation With Control Built In</h2>
                              <p >
                              Effective automation is not measured only by the number of tasks performed without human involvement. It should also improve process consistency, traceability and the ability to handle exceptions safely.
                              </p>
                              <p>We design around appropriate permissions, validation, human oversight and fallback procedures—especially where actions affect money, sensitive information, public services or important business decisions.</p>
                            </div>     
                          </div>
                                            {/* ── RIGHT:  ── */}
                            <div   data-aos="fade-left">  
                              <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
                                <h6>Connect Intelligent Automation to Your Existing Software</h6>
                                <p style={{ paddingBottom: '1.2rem' }}>
                                  From a single repetitive task to a multi-step operational workflow, CruxBytes can help turn suitable AI opportunities into integrated business applications.
                                </p>
                                
                              </div>
                            </div>
                  
                                    </div>
                           
                                  </div>
                           </section>
         <TransformBanner />
         </main></>
  )
}